import React from 'react';

// Unified status badge (pill). Two ways to use it:
//   1. Binary active/inactive — <FigmaBadge Active={item.IsActive} />
//   2. Named status variant   — <FigmaBadge variant='confirmed' label='Confirmed' />
// `variant` wins when supplied; otherwise the Active flag picks active/inactive
// and ActiveText/InactiveText supply the label.
// Styling: the global .badgebase family in src/index.css (unscoped, so it renders
// on non-bravo-ds pages too). Variants: active, inactive, created, confirmed,
// planned, completed, todo, progress, testing, uat.
export default class FigmaBadge extends React.Component {
  static defaultProps = {
    Active: true,
    ActiveText: 'Active',
    InactiveText: 'Inactive',
    tooltip: '',
  };

  render() {
    const useVariant = !!this.props.variant;
    const variant = useVariant ? this.props.variant : this.props.Active ? 'active' : 'inactive';
    const label = useVariant
      ? this.props.label
      : this.props.Active
      ? this.props.ActiveText
      : this.props.InactiveText;

    // Legacy Active badges keep their historical fixed column width (80px default)
    // when none is given; named-variant pills are auto-width unless a width is passed.
    const hasWidth = this.props.width != null;
    const width = hasWidth ? this.props.width : useVariant ? null : 80;

    return (
      <span
        className={`badgebase ${variant}`}
        style={width != null ? { width: `${width}px` } : undefined}
        title={this.props.tooltip}
      >
        <span className='dot' />
        <span className='badgelabel'>{label}</span>
      </span>
    );
  }
}
